import React from 'react';

import { OverviewRiskItem } from 'dashboard/types';

import * as Styled from 'dashboard/styles/Overview.style';
import * as Text from 'theme/components/Text.style';

interface RisksCardProps {
  data: OverviewRiskItem[] | undefined;
  isLoading: boolean;
}

function formatRiskLabel(risk: string): string {
  return risk.replace(/\s*Risk$/i, '');
}

export default function RisksCard({
  data,
  isLoading,
}: RisksCardProps): JSX.Element {
  return (
    <Styled.StatRowsContainer>
      {isLoading || !data ? (
        <Styled.HorizontalStatRow>
          <Text.H3>–</Text.H3>
        </Styled.HorizontalStatRow>
      ) : (
        data.slice(0, 4).map((item) => (
          <Styled.HorizontalStatRow key={item.risk_key}>
            <Text.H3>{item.percentage}%</Text.H3>
            <Text.LabelSemibold style={{ textAlign: 'right' }}>
              {formatRiskLabel(item.risk)}
            </Text.LabelSemibold>
          </Styled.HorizontalStatRow>
        ))
      )}
    </Styled.StatRowsContainer>
  );
}
